import React, { Component } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { RadioButton, RadioButtonGroup } from 'material-ui';
import _ from 'lodash';
import * as dateTypes from '../../../common/config/DateTypeConstants';

export const DATE_FIELDS = [
  { value: dateTypes.DESPATCH_CLOSED_DATE, text: 'Despatch Closed date' },
  { value: dateTypes.DESPATCH_PLANNED_DEPARTURE_DATE, text: 'Despatch Planned departure date' },
  { value: dateTypes.DESPATCH_PLANNED_ARRIVAL_DATE, text: 'Despatch Planned arrival date' },
  { value: dateTypes.INTERCHANGE_PREPARATION_DATE, text: 'Interchange Preparation date' },
  { value: dateTypes.CONSIGNMENT_COMPLETION_DATE, text: 'Consignment Completion date' },
  { value: dateTypes.ON_NETWORK_DATE, text: 'On network date' },
  { value: dateTypes.POSTAL_SCAN_DATE, text: 'Postal Scan date' },
  { value: dateTypes.HANDOVER_REGISTRATION_TIME, text: 'Handover registration time' },
  { value: dateTypes.HANDOVER_REGISTRATION_DATE, text: 'Handover Registration date' },
  { value: dateTypes.CARDIT_CONSIGNMENT_COMPLETION_DATE, text: 'CARDIT Consignment Completion date' },
  { value: dateTypes.CARDIT_FIRST_LEG_PLANNED_DEPARTURE_DATE, text: 'CARDIT First Leg: Planned Departure date' },
  { value: dateTypes.MESSAGE_PREPARATION_DATE, text: 'Message Preparation Date' },
  { value: dateTypes.CARDIT_PLANNED_DEPARTURE_DATE, text: 'CARDIT Planned Departure date' },
  { value: dateTypes.CARDIT_PLANNED_ARRIVAL_DATE, text: 'CARDIT Planned Arrival date' },
  { value: dateTypes.MRD_HANDOVER_REGISTRATION_DATE, text: 'MRD Handover Registration date' },
  { value: dateTypes.PERIOD, text: 'Period' },
  { value: dateTypes.BASE_DATE_RANGE, text: 'Base Date Range' },
  { value: dateTypes.EVENT_DATE, text: 'Event date' },
  { value: dateTypes.REPORT_GENERATION_DATE, text: 'Report Generation Date' },
  { value: dateTypes.ENTRY_DATE, text: 'Event Date' },
  { value: dateTypes.LEG3_START_DATE, text: 'Leg 3 start date' },
];

class DateFieldSelector extends Component {
  constructor(props) {
    super(props);
    props.onChange(props.selectedDateType);
  }

  handleChange = (event) => {
    this.props.onChange(event.target.value);
  };

  render() {
    return (
      <div>
        <RadioButtonGroup
          onChange={this.handleChange}
          name="ReportDateField"
          valueSelected={this.props.selectedDateType}
        >
          {this.props.dateTypes.map((field) => {
            const dateTypeField = _.find(DATE_FIELDS, { value: field });
              return (
                <RadioButton
                  value={dateTypeField.value}
                  label={dateTypeField.text}
                  key={dateTypeField.value}
                />
              );
          })}
        </RadioButtonGroup>
      </div>
    );
  }
}

export default DateFieldSelector;

DateFieldSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  dateTypes: PropTypes.arrayOf(PropTypes.string),
  selectedDateType: PropTypes.string,
};
